<template>
  <q-dialog
    v-model="shown"
    transition-show="fade-in"
    transition-hide="fade-out"
    @keyup.escape.stop="shown = false"
  >
    <q-card
      class="column col"
      style="max-width: 1000px; min-height: 90%;"
      flat
    >
      <q-inner-loading :showing="loading" />
      <div class="row q-mx-md items-center q-gutter-sm">
        <div
          class="col row justify-start items-center"
          style="flex-grow: 1"
        >
          <q-btn
            icon="close"
            flat
            dense
            @click="shown = false"
          />
        </div>
        <div
          class="col row justify-start items-center"
          style="flex-grow: 1"
        >
          <div class="col-auto text-h6">
            <div class="row items-center">
              Modify Membership ({{ membership.id }})

              <q-icon
                name="business"
                size="sm"
                class="q-ml-sm"
              >
                <q-tooltip>
                  Circuit Level
                </q-tooltip>
              </q-icon>
            </div>
          </div>
        </div>
        <div
          class="col row justify-end items-center"
          style="flex-grow: 1"
        >
          <q-btn
            label="Revert"
            :disable="!showCart"
            :loading="checkoutLoading"
            @click="revert"
          />
          <q-btn
            label="Save and Close"
            color="primary"
            :disable="!showCart || !canCheckout"
            :loading="checkoutLoading"
            @click="modifyMembership"
          />
        </div>
      </div>
      <div
        v-if="showCart"
        class="column col"
      >
        <span
          class="q-mb-md q-mx-auto text-center text-black text-bold"
        >
          A membership order has been generated to modify this membership.
          <q-icon name="info">
            <q-tooltip>
              The existing interval has been refunded with a prorated charge for any used days. A new interval has been created with the specified modifications.
              <br>As the used days have been prorated, there will be no change in your reported daily membership revenue. <b>All existing reporting will remain accurate.</b>
              <br>There will be no additional charges placed for the modification, but the user's renewal fee may have changed. <b>Please be sure that the user has agreed to any fee changes.</b>
            </q-tooltip>
          </q-icon>
        </span>
        <cart
          class="column col"
          view-only
          display-total
          hide-redemptions
        />
      </div>
      <modify-membership-form
        v-else-if="!loading"
        class="column col"
        :order="order"
        @membership-order-created="checkout"
      />
    </q-card>
  </q-dialog>
</template>

<script>
import Membership from 'src/models/membership/Membership'
import Order, { ORDER_CHECKOUT_DEFAULT_OPTIONS } from 'src/models/order/Order'
import Cart from 'src/modules/register/components/Cart'
import ModifyMembershipForm from 'src/modules/register/membership/ModifyMembershipForm'

const order = new Order({}, ORDER_CHECKOUT_DEFAULT_OPTIONS)

export default {
  name: 'AdminModifyMembership',
  components: {
    Cart,
    ModifyMembershipForm
  },
  provide: {
    order,
    checkoutData: null
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    membership: {
      type: Membership,
      required: true
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      order,
      showCart: false,
      canCheckout: false,
      loading: true,
      checkoutLoading: false
    }
  },
  models: {
    user: {
      membership: {
        currentMembershipInterval: 'default',
        members: 'default',
        owner: 'default'
      },
      variables () {
        return {
          id: this.membership.owner.id,
          skip: !this.membership.owner.isRemote
        }
      }
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    },
    'membership.id': {
      async handler () {
        if (!this.membership?.owner?.isRemote) return

        this.loading = true
        await this.$nextTick()
        this.order.reset()
        await this.user.ensureLoaded()
        this.order.setRelated('user', this.user)
        this.loading = false
      },
      immediate: true
    }
  },
  methods: {
    show () {
      this.showCart = false
      this.checkoutLoading = false
      this.canCheckout = false
      this.shown = true
    },
    revert () {
      this.showCart = false
      this.checkoutLoading = false
      this.canCheckout = false
    },
    checkout () {
      this.canCheckout = this.order.total === 0
      this.checkoutLoading = false
      this.showCart = true
    },
    async modifyMembership () {
      this.canCheckout = false
      this.checkoutLoading = true
      await this.order.place()
      this.membership.fetch(true)
      this.canCheckout = false
      this.checkoutLoading = false
      this.shown = false
      this.order.reset()
      this.order.setRelated('user', this.user)
    }
  }
}

</script>
